import AppConfig from './config'

import Vue from 'vue'
import App from './App.vue'
// import './registerServiceWorker'
import router from './router'
import store from './store'

import { Bootstrapper } from 'tradingmate-modules/src/startup'

import './components/global'
import { Services } from 'tradingmate-modules/src/services'
// import { Logger, LogLevel } from 'tradingmate-modules/src/debug/Logger'
import { BusinessBranchStatus } from '../../tradingmate-modules/src/models/api/businesses'

Vue.config.productionTip = false

Bootstrapper.Initialise(AppConfig).then(() => {
  // store.commit('ui/bootstrap')

  router.beforeEach((to, from, next) => {
    // If route allows anoymous skip all other checks
    if (to.meta?.allowAnon)
    {
      console.log('allow anon')
      next()
    }

    // Todo Setstate upon checkout, possibly with delay to update the users BusinessBranchStatus OR replace this with a dynamic API call
    // Check for user login
    else if (store.state.identity.LoggedIn) {
      console.log('logged in')

      // If attempting to access dashboard or profile allow it
      if (to.path === '/' || to.path === '/profile' || to.name === 'Business Branch Edit') {
        next()

        return
      }

      // Check for user membership status
      if (store.state.identity.BusinessBranch?.Status === BusinessBranchStatus.Active ||
        store.state.identity.BusinessBranch?.Status === BusinessBranchStatus.Express ||
        store.state.identity.BusinessBranch?.Status === BusinessBranchStatus.WantingCancel ||
        store.state.identity.BusinessBranch?.Status === BusinessBranchStatus.AdminAccount) {
        next()
      }
      else {
        console.log('Membership not active')
        console.log(to.name)

        if (to.name === 'Logout')
        {
          next()
        }
        else if (to.name === 'Membership')
        {
          next()
        }
        else {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          next({ name: 'Membership', params: { id: store.state.identity.BusinessBranch?.BusinessBranchId } })
        }
      }
    }
    else {
      // Check to see if we have a session
      store.commit('ui/setLoading', true)

      Services.API.Users.Me()
        .then(me => {
          store.commit('identity/setUser', me)

          return Services.API.Users.GetBusinessBranches()
        })
        .then(branches => {
          store.commit('identity/setBranch', branches[0])

          store.commit('ui/setLoading', false)

          next()
        })
        .catch(() => {
          store.commit('ui/setLoading', false)

          console.log('next to fullpath')
          next({
            path: '/account/login',
            query: {
              next: to.fullPath
            }
          })
        })
    }
  })

  const mountApp = (success: boolean) => {
    const app = new Vue({
      router: success ? router : undefined,
      store,
      render: h => h(App)
    })

    app.$mount('#app')
  }

  // Services.API.Telemetry.Ping()
  //   .then(success => {
  //     store.commit('env/setErrored', !success)

  //     mountApp(success)
  //   })
  //   .catch(ex => {
  //     // Logger.Log(LogLevel.Critical, ex)

  //     // For now ignore the API ping
  //     // store.commit('env/setErrored', true)
  //     store.commit('env/setErrored', false)

  //     // mountApp(false)
  //     mountApp(true)
  //   })

  mountApp(true)
})
